import { render, staticRenderFns } from "./ProtectedBag.vue?vue&type=template&id=3a043abc&scoped=true"
import script from "./ProtectedBag.vue?vue&type=script&lang=js"
export * from "./ProtectedBag.vue?vue&type=script&lang=js"
import style0 from "./ProtectedBag.vue?vue&type=style&index=0&id=3a043abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a043abc",
  null
  
)

export default component.exports